import { composeIO } from 'react-compose-io'
import { modalClassificacoesPorMesIO } from './ModalClassificacoesPorMes.IO'
import { ModalClassificacoesPorMesView } from './ModalClassificacoesPorMes.View'

export const ModalClassificacoesPorMes = composeIO(ModalClassificacoesPorMesView, modalClassificacoesPorMesIO)
